import React from 'react';
import styled from 'styled-components';
import { Modal, Skeleton } from 'antd';
import { QrcodeOutlined } from '@ant-design/icons';

import { regenPlasticSurgery, regenPlasticSurgery2, regenQr, wechatSvg, wechatPng } from '../../images';

const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

const BackgroundImg = styled.img`
  width: 100%;
  background-size: cover;
`;

const IconWrapper = styled.div`
  position: fixed;
  right: 25px;
  bottom: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const WechatIcon = styled.img`
  width: 5rem;
  height: 5rem;
  background-size: cover;
`;

const IconText = styled.div`
  margin: 5px 0;
  color: #09B83E;
  font-weight: 600;
`;

export default function RegenPlasticPresenter() {
  const [ isModalOpen, setIsModalOpen ] = React.useState( false );

  const showModal = () => setIsModalOpen( true );
  const handleCancel = () => setIsModalOpen( false );

  const modalController = { isModalOpen, handleCancel };

  return (
    <Container>
      <BackgroundImg src={regenPlasticSurgery2} />

      <IconWrapper>
        <WechatIcon src={wechatSvg} onClick={showModal} />
        <IconText>WeChat咨询</IconText>
      </IconWrapper>

      <QrModal modalController={modalController} />
    </Container>
  );
}

const QrModalWrapper = styled.div`
  width:  100%;
  height: 30rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const QrImg = styled.img`
  width: 100%;
`;

const QrModal = ({ modalController }) => {
  const { isModalOpen, handleCancel } = modalController;

  return (
    <Modal title='위챗 상담 QR' open={isModalOpen} onCancel={handleCancel} centered footer={null} >
      <QrModalWrapper>
        { regenQr ? <QrImg src={regenQr} /> : <Skel /> }
      </QrModalWrapper>
    </Modal>
  );
}

const SkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const SkeletonText = styled.div`
  margin: 50px 0;
  color: #bfbfbf;
  font-weight: 600;
  text-align: center;
`;

const Skel = () => (
  <SkeletonWrapper>
    <Skeleton.Node active fullSize>
      <QrcodeOutlined style={{ fontSize: 80, color: '#bfbfbf' }} />
    </Skeleton.Node>
    <SkeletonText>Loading...</SkeletonText>
  </SkeletonWrapper>
);
